import { render, staticRenderFns } from "./HaulageRevenueDrillThrough.vue?vue&type=template&id=795bd588&scoped=true&"
import script from "./HaulageRevenueDrillThrough.vue?vue&type=script&lang=js&"
export * from "./HaulageRevenueDrillThrough.vue?vue&type=script&lang=js&"
import style0 from "./HaulageRevenueDrillThrough.vue?vue&type=style&index=0&id=795bd588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bd588",
  null
  
)

export default component.exports